import { createSlice } from "@reduxjs/toolkit";

const DEFAULT_THANKS_POPUP_CONFIG = {
  title: "Registration Successful",
  message: "Your account has been created. Please log in to continue.",
  redirectToLogin: true,
};

const initialState = {
  isLoginModalVisible: false,
  isSingupModalVisible: false,
  isMobileOtpModalVisible: false,
  isPhoneNumberModalVisible: false,
  openCompletionModal: false,
  isMobileVerificationCompleted: false,
  showForgotPasswordModal: false,
  isFromForgotPassword: false,
  nextStep: "",
  countdown: 30,
  paymentModal: "",
  paymentType: "",
  selectedModal: null,
  mobileLogin: false,
  thanksPopupVisible: false,
  thanksPopupConfig: DEFAULT_THANKS_POPUP_CONFIG,
  registerSuccessPromptVisible: false,
  mpinSetupPromptVisible: false,
  setMpinModalVisible: false,
  setMpinModalFromMenu: false,
  openUsernameSetupModal: false,
  depositData: {},
  initialOtpVerification: false,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openLoginModal: (state, action) => {
      state.isFromForgotPassword = false;
      state.isLoginModalVisible = true;
      state.selectedModal = action.payload;
      state.initialOtpVerification = false;
    },
    closeLoginModal: (state) => {
      state.isLoginModalVisible = false;
      state.selectedModal = null;
    },
    toggleMobileModal: (state) => {
      state.mobileLogin = !state.mobileLogin;
    },
    openSignupModal: (state) => {
      state.isSingupModalVisible = true;
    },
    closeSignupModal: (state) => {
      state.isSingupModalVisible = false;
    },
    openMobileOtpModal: (state, action) => {
      state.isFromForgotPassword = false;
      state.isMobileOtpModalVisible = true;
      if (action.payload) state.isFromForgotPassword = true;
    },
    closeMobileOtpModal: (state) => {
      state.isMobileOtpModalVisible = false;
      state.completionModal = true;
    },
    openPhoneNumberModal: (state) => {
      state.isPhoneNumberModalVisible = true;
    },
    closePhoneNumberModal: (state) => {
      state.isPhoneNumberModalVisible = false;
    },
    openPopup: (state, action) => {
      if (action.payload === "mobile")
        state.isMobileVerificationCompleted = true;
      else state.isMobileVerificationCompleted = false;
      state.openCompletionModal = true;
    },
    closePopup: (state) => {
      state.openCompletionModal = false;
    },
    openThanksPopup: (state, action) => {
      state.thanksPopupVisible = true;
      state.thanksPopupConfig = {
        ...DEFAULT_THANKS_POPUP_CONFIG,
        ...(action.payload || {}),
      };
    },

    closeThanksPopup: (state) => {
      state.thanksPopupVisible = false;
      state.thanksPopupConfig = DEFAULT_THANKS_POPUP_CONFIG;
    },
    openRegisterSuccessPrompt: (state) => {
      state.registerSuccessPromptVisible = true;
    },
    closeRegisterSuccessPrompt: (state) => {
      state.registerSuccessPromptVisible = false;
    },
    openMpinSetupPrompt: (state) => {
      state.mpinSetupPromptVisible = true;
    },
    closeMpinSetupPrompt: (state) => {
      state.mpinSetupPromptVisible = false;
    },
    openSetMpinModal: (state, action) => {
      state.setMpinModalVisible = true;
      state.setMpinModalFromMenu = action.payload?.fromMenu ?? false;
    },
    closeSetMpinModal: (state) => {
      state.setMpinModalVisible = false;
      state.setMpinModalFromMenu = false;
    },
    openUsernameSetupModal: (state) => {
      state.openUsernameSetupModal = true;
    },
    closeUsernameSetupModal: (state) => {
      state.openUsernameSetupModal = false;
    },
    tick: (state) => {
      state.countdown -= 1;
    },
    resetCountdown: (state) => {
      state.countdown = 30;
    },
    closeforgotPasswordModal: (state) => {
      state.showForgotPasswordModal = false;
    },
    openforgotPasswordModal: (state, action) => {
      state.initialOtpVerification = action.payload;
      state.showForgotPasswordModal = true;
    },
    openPaymentModal: (state, action) => {
      state.paymentModal = action.payload;
    },
    closePaymentModal: (state) => {
      state.paymentModal = "";
    },
    setNextStep: (state, action) => {
      state.nextStep = action.payload;
    },
    openPaymentMethod: (state, action) => {
      const { amount, offerCode, paymentMethodId, bonusTemplateId } =
        action.payload;
      state.depositData.amount = amount;
      state.depositData.offerCode = offerCode;
      state.depositData.paymentMethodId = paymentMethodId;
      state.depositData.bonusTemplateId = bonusTemplateId;
      state.nextStep = action.payload.nextStep;
    },
    closePaymentMethod: (state) => {
      state.nextStep = "";
    },
    // the deposit flow closed: the next one starts without the old method/offer
    clearDepositData: (state) => {
      state.depositData = {};
      state.nextStep = "";
    },
    openPaymentCompletionModal: (state, action) => {
      state.paymentType = action.payload;
    },
    closePaymentCompletionModal: (state) => {
      state.paymentType = "";
    },
  },
});

export const {
  openLoginModal,
  closeLoginModal,
  openSignupModal,
  closeSignupModal,
  openMobileOtpModal,
  closeMobileOtpModal,
  openPhoneNumberModal,
  closePhoneNumberModal,
  tick,
  resetCountdown,
  openPopup,
  closePopup,
  openforgotPasswordModal,
  closeforgotPasswordModal,
  openPaymentModal,
  closePaymentModal,
  setNextStep,
  openPaymentMethod,
  closePaymentMethod,
  clearDepositData,
  openPaymentCompletionModal,
  closePaymentCompletionModal,
  toggleMobileModal,
  openThanksPopup,
  closeThanksPopup,
  openRegisterSuccessPrompt,
  closeRegisterSuccessPrompt,
  openMpinSetupPrompt,
  closeMpinSetupPrompt,
  openSetMpinModal,
  closeSetMpinModal,
  openUsernameSetupModal,
  closeUsernameSetupModal,
} = modalSlice.actions;

export default modalSlice.reducer;
